import React, { useRef } from 'react'
import clientData from '../../../../client/src/utils/client-data'
import { getSendUrl } from '../../../../client/src/utils/generate-urls'
import { get } from 'lodash'
import glamorous from 'glamorous'
import {
  Alert,
  HeadingText,
  v2grey600,
  grey600,
  grey700,
  blue600,
  v2black,
  Button,
  v2blue400,
  Divider,
  white,
  V2MailIcon,
  V2PhoneIcon,
  Link,
} from '@paypalcorp/pp-react'
import SocialLinks from './social/social-links'
import getContent from 'pp-react-l10n'
import { getReportLink } from '../../utils/generate-urls'
import { COVER_PHOTO_URLS } from '../../utils/constants'
import { tracking } from 'lib/analytics'
import Events from 'lib/analytics/event-tags'
const l10n = getContent('pages/seller/preview')

const disabledMod = {
  '& .disabledLink, & .disabledLink:focus, & .disabledLink:active, & .disabledLink:hover': {
    pointerEvents: 'none',
    textDecoration: 'none',
    outline: 'none',
    boxShadow: 'none',
    color: v2blue400,
  },
  '& .disabledBtn, & .disabledBtn:focus, & .disabledBtn:active, & .disabledBtn:hover': {
    border: 'none',
    pointerEvents: 'none',
    textDecoration: 'none',
    outline: 'none',
    boxShadow: 'none',
    backgroundColor: blue600,
  },
  '& .disabledBtn::after': {
    border: 'none',
    pointerEvents: 'none',
    textDecoration: 'none',
    outline: 'none',
    boxShadow: 'none',
  },
}

const Container = glamorous.div(props => ({
  fontFamily: 'PayPalSansBig-Regular,"Helvetica Neue",Arial,sans-serif',
  margin: '-30px 0 0 0',
  padding: 15,
  width: '100%',
  minWidth: 320,
  maxWidth: props.isSellerDashboardPreview ? 'unset' : 612,
  '& div[role=heading]': {
    color: grey700,
    textAlign: 'left',
  },
  '& div[role=heading] + p': {
    color: grey600,
    fontFamily: 'PayPalSansBig-Regular,"Helvetica Neue",Arial,sans-serif',
    fontSize: '1rem',
    margin: '0.5rem 0',
  },
  '& .report-profile': {
    marginTop: 20,
    textAlign: 'center',
    display: 'inline-block',
    fontSize: '0.875rem',
    width: '100%',
  },
  ...disabledMod,
}))

const BackgroundPhoto = glamorous.div(({ image, pan }) => ({
  boxSizing: 'border-box',
  width: '100%',
  '& > div:first-child': {
    borderRadius: '13px 13px 0 0',
    backgroundImage: `url(${encodeURI(image)})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPositionX: '50%',
    backgroundPositionY: `${pan}%`,
    width: '100%',
    paddingBottom: '32%',
    maxHeight: 293,
    position: 'relative',
  },
}))

const Logo = glamorous.div(({ image }) => ({
  height: '20vw',
  width: '20vw',
  maxHeight: 85,
  maxWidth: 85,
  minHeight: 65,
  minWidth: 65,
  borderRadius: '50%',
  backgroundImage: `url(${encodeURI(image)})`,
  backgroundRepeat: 'no-repeat',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
  position: 'absolute',
  left: 'calc(5% + 10px)',
  bottom: 0,
  transform: 'translateY(50%)',
  border: white + ' solid 3px',
  boxSizing: 'content-box',
}))

const PreviewBlock = glamorous.div({
  borderRadius: 13,
  minHeight: 400,
  margin: '40px 0',
  backgroundColor: white,
  '& p': {
    fontFamily: 'PayPalSansBig-Regular,"Helvetica Neue",Arial,sans-serif',
  },
})

const ContentBlock = glamorous.div({
  padding: '0 10%',
  '@media (max-width: 414px)': {
    padding: '0 3%',
  },
  '& hr': {
    margin: '24px 0',
  },
  '& .aboutBlock': {
    color: v2black,
    fontWeight: 'bold',
    fontSize: '0.857rem',
    lineHeight: '1rem',
  },
  '& .aboutBlock + p': {
    color: v2grey600,
    fontSize: '0.857rem',
    lineHeight: '1rem',
  },
  '& .contacts': {
    '& p, & a': {
      fontSize: '0.857rem',
      lineHeight: '1rem',
    },
    '& .email span': {
      color: grey700,
    },
    '& p': {
      '& span': {
        marginRight: '0.375rem',
        transform: 'translateY(4px)',
      },
    },
    '& a svg': {
      transform: 'translateY(2px)',
    },
  },
  '& .payButton': {
    textAlign: 'center',
    '& button': {
      padding: 0,
      margin: '40px auto',
      lineHeight: 1,
      width: 226,
      height: 36,
    },
  },
})

const AboutDescriptionText = glamorous.p({
  wordWrap: 'break-word',
})

const SellerName = glamorous.h2({
  fontSize: '1.125rem',
  fontWeight: 'normal',
  lineHeight: '1.5rem',
  margin: '12% 0 5px 0',
  padding: '10px 0 0 0',
  overflowWrap: 'break-word',
})

const Slug = glamorous.p({
  fontFamily: 'PayPalSansBig-Regular,"Helvetica Neue",Arial,sans-serif',
  fontSize: '0.857rem',
  lineHeight: '1rem',
})

const LocationText = glamorous.p({
  color: grey600,
  fontFamily: 'PayPalSansBig-Regular,"Helvetica Neue",Arial,sans-serif',
  fontSize: '0.857rem',
  lineHeight: '1rem',
  marginBottom: 20,
})

const LocationTextPlaceHolder = glamorous.p({
  clear: 'both',
  width: '100%',
  height: 5,
})

Preview.defaultProps = {
  previewData: {
    paypalmeSlugName: get(clientData, 'sellerProfileDetails.id'),
    personalizationSettings: {
      coverPhotoUrl:
        get(
          clientData,
          'sellerProfileDetails.personalization_settings.cover_photo_url',
        ) || COVER_PHOTO_URLS.BLUE.VECTOR,
      coverPhotoVerticalPan: get(
        clientData,
        'sellerProfileDetails.personalization_settings.cover_photo_vertical_pan',
      ),
      description: get(
        clientData,
        'sellerProfileDetails.personalization_settings.description',
      ),
    },
    privacySettings: {
      displayEmailEnabled:
        get(
          clientData,
          'sellerProfileDetails.privacy_settings.display_email_enabled',
        ) || false,
      displayMobilePhoneEnabled:
        get(
          clientData,
          'sellerProfileDetails.privacy_settings.display_mobile_phone_enabled',
        ) || false,
    },
    userInfo: {
      displayEmail: get(
        clientData,
        'sellerProfileDetails.user_info.display_email',
      ),
      displayMobilePhone: get(
        clientData,
        'sellerProfileDetails.user_info.display_mobile_phone',
      ),
      displayAddress: get(
        clientData,
        'sellerProfileDetails.user_info.display_address',
      ),
      instagramUsername: get(
        clientData,
        'sellerProfileDetails.user_info.instagram_username',
      ),
      facebookUrl: get(
        clientData,
        'sellerProfileDetails.user_info.facebook_url',
      ),
      twitterHandle: get(
        clientData,
        'sellerProfileDetails.user_info.twitter_handle',
      ),
      alternateFullName: get(
        clientData,
        'sellerProfileDetails.user_info.alternate_full_name',
      ),
    },
  },
}

function constructPreviewData(sellerProfileState) {
  const state = get(sellerProfileState, 'state') || {}
  return {
    paypalmeSlugName: get(state, 'sellerProfileDetails.id'),
    personalizationSettings: {
      coverPhotoUrl:
        get(
          state,
          'sellerProfileDetails.personalization_settings.cover_photo_url',
        ) || COVER_PHOTO_URLS.BLUE.VECTOR,
      coverPhotoVerticalPan: get(
        state,
        'sellerProfileDetails.personalization_settings.cover_photo_vertical_pan',
      ),
      description: get(
        state,
        'sellerProfileDetails.personalization_settings.description',
      ),
    },
    privacySettings: {
      displayEmailEnabled:
        get(
          state,
          'sellerProfileDetails.privacy_settings.display_email_enabled',
        ) || false,
      displayMobilePhoneEnabled:
        get(
          state,
          'sellerProfileDetails.privacy_settings.display_mobile_phone_enabled',
        ) || false,
    },
    userInfo: {
      displayEmail: get(state, 'sellerProfileDetails.user_info.display_email'),
      displayMobilePhone: get(
        state,
        'sellerProfileDetails.user_info.display_mobile_phone',
      ),
      displayAddress: get(
        state,
        'sellerProfileDetails.user_info.display_address',
      ),
      instagramUsername: get(
        state,
        'sellerProfileDetails.user_info.instagram_username',
      ),
      facebookUrl: get(state, 'sellerProfileDetails.user_info.facebook_url'),
      twitterHandle: get(
        state,
        'sellerProfileDetails.user_info.twitter_handle',
      ),
      alternateFullName: get(
        state,
        'sellerProfileDetails.user_info.alternate_full_name',
      ),
      profilePhotoUrl: get(
        state,
        'sellerProfileDetails.user_info.profile_photo_url',
      ),
    },
  }
}

function Preview(props) {
  let {
    previewData = {},
    sellerProfileState = {},
    match = {},
    history = () => {},
  } = props

  const isSellerDashboardPreview =
    match?.url.split('/')[3] === 'dashboard' &&
    match?.url.split('/')[4] === 'preview'

  // If seller is in dashboard/preview, then use state instead of clientData
  if (isSellerDashboardPreview) {
    previewData = constructPreviewData(sellerProfileState)
  }

  const { current: isUserLoggedIn } = useRef(clientData.isUserLoggedIn)

  const handlePayButton = () => {
    tracking(Events.public_identity_profile_pay_pressed())
    const payUrl = getSendUrl({
      isLoggedIn: isUserLoggedIn,
      previewData,
    })
    window.location.href = payUrl
  }

  React.useEffect(() => {
    tracking(Events.public_identity_profile_screen_shown())
  }, [])

  const copyLink = `https://paypal.me/${get(
    previewData,
    'paypalmeSlugName',
  )}?locale.x=${get(clientData, 'locality.locale')}`

  return (
    <Container
      data-test-id="seller-dashboard-preview-screen"
      isSellerDashboardPreview={isSellerDashboardPreview}
    >
      {isSellerDashboardPreview ? (
        <Alert
          type="success"
          aria-level="1"
          closeButton={{
            'aria-label': l10n('dismissAlert'),
            onClick: () => {
              history.push(
                `/seller/${get(previewData, 'paypalmeSlugName')}/dashboard`,
              )
            },
          }}
        >
          {l10n('description')}
        </Alert>
      ) : null}
      <PreviewBlock data-test-id="seller-dashboard-preview-block">
        <BackgroundPhoto
          image={get(previewData, 'personalizationSettings.coverPhotoUrl')}
          pan={get(
            previewData,
            'personalizationSettings.coverPhotoVerticalPan',
          )}
          data-test-id="seller-dashboard-preview-background"
        >
          {/* inner div here for maintaining the aspect ratio*/}
          <div role="banner">
            <Logo
              image={get(previewData, 'userInfo.profilePhotoUrl')}
              data-test-id="seller-dashboard-preview-logo"
            />
          </div>
        </BackgroundPhoto>
        <ContentBlock>
          <SellerName role="heading" aria-level="2">
            {get(previewData, 'userInfo.alternateFullName')}
          </SellerName>

          <Slug>@{get(previewData, 'paypalmeSlugName')}</Slug>

          {get(previewData, 'userInfo.displayAddress') ? (
            <LocationText>
              {get(previewData, 'userInfo.displayAddress')}
            </LocationText>
          ) : (
            <LocationTextPlaceHolder />
          )}

          <SocialLinks
            disabledLinks={isSellerDashboardPreview}
            instagramUsername={get(previewData, 'userInfo.instagramUsername')}
            facebookUrl={get(previewData, 'userInfo.facebookUrl')}
            twitterHandle={get(previewData, 'userInfo.twitterHandle')}
            copyLink={copyLink}
            sellerName={get(previewData, 'userInfo.alternateFullName')}
          />
          <Divider />
          <HeadingText className="aboutBlock" size="sm">
            {l10n('about')}
          </HeadingText>
          <AboutDescriptionText>
            {get(previewData, 'personalizationSettings.description')}
          </AboutDescriptionText>
          <div className="contacts">
            {get(previewData, 'userInfo.displayMobilePhone') &&
            get(previewData, 'privacySettings.displayMobilePhoneEnabled') ? (
              <p>
                <V2PhoneIcon size="xs" />
                {get(previewData, 'userInfo.displayMobilePhone')}
              </p>
            ) : null}

            {get(previewData, 'userInfo.displayEmail') &&
            get(previewData, 'privacySettings.displayEmailEnabled') ? (
              <Link
                className={
                  isSellerDashboardPreview ? 'email disabledLink' : 'email'
                }
                onClick={e => {
                  isSellerDashboardPreview
                    ? e.preventDefault()
                    : tracking(Events.public_identity_profile_email_pressed())
                }}
                href={`mailto:${get(previewData, 'userInfo.displayEmail')}`}
                leftIcon={<V2MailIcon size="xs" />}
                theme="v2"
                data-test-id="seller-dashboard-preview-email"
              >
                {get(previewData, 'userInfo.displayEmail')}
              </Link>
            ) : null}
          </div>

          <div className="payButton">
            <Button
              className={isSellerDashboardPreview ? 'disabledBtn' : ''}
              disabled={isSellerDashboardPreview ? true : false}
              onClick={e => {
                isSellerDashboardPreview
                  ? e.preventDefault()
                  : handlePayButton()
              }}
              data-test-id="seller-dashboard-preview-pay"
            >
              {l10n('pay')}
            </Button>
          </div>
        </ContentBlock>
      </PreviewBlock>
      {isSellerDashboardPreview ? null : (
        <Link
          className="report-profile"
          onClick={() =>
            tracking(Events.public_identity_profile_report_pressed())
          }
          href={getReportLink()}
          theme="v2"
          data-test-id="seller-dashboard-preview-report"
        >
          {l10n('reportProfile')}
        </Link>
      )}
    </Container>
  )
}
export default Preview
